import { EffectsModal } from '../EffectsModal';

export const MissingModal = ({ title }) => EffectsModal({
  title,
  desc: 'Whenever possible, numbers of missing are listed.',
});
